import { useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
export function useFixedOptions({ value, onChange, isOptionDisabled: isOptionDisabledProp, }) {
    const fixedValues = useMemo(() => (Array.isArray(value) ? value.filter((option) => option.fixed) : []), [value]);
    const handleChange = useCallbackRef((newValue, actionMeta) => {
        switch (actionMeta.action) {
            case 'clear':
                onChange?.(fixedValues, actionMeta);
                return;
            case 'deselect-option':
                if (actionMeta.option?.fixed)
                    return;
                break;
            case 'remove-value':
            case 'pop-value':
                if (actionMeta.removedValue?.fixed)
                    return;
                break;
        }
        onChange?.(newValue, actionMeta);
    });
    const isOptionDisabled = useCallbackRef((option, selectValue) => {
        if (option.fixed) {
            return true;
        }
        if (isOptionDisabledProp) {
            return isOptionDisabledProp(option, selectValue);
        }
        return false;
    });
    if (!fixedValues.length) {
        return undefined;
    }
    return {
        onChange: handleChange,
        isClearable: fixedValues.length < (Array.isArray(value) ? value.length : 0),
        isOptionDisabled,
    };
}
